import States from './States.jsx';

export default function GetStateLabel(stateValue) {
    const states = States();
    const stateLabel = states.find(e => e.value === stateValue);
    if (stateLabel && stateLabel.label) {
       return  stateLabel.label;
    }
    return stateValue;
} 